import React from 'react';
import PropTypes from 'prop-types';

import {
  CircularProgress,
  Grid,
  IconButton,
  Typography
} from '@material-ui/core';

import CachedIcon from '@material-ui/icons/Cached';

import * as api from '_core/utils/api';
import { useGlobal } from '_core/hooks/useGlobal';
import { withLang } from '_core/hocs/withLang';
import { FormWithValidation } from '_core/components/FormWithValidation';
import { ClipboardInput } from '_core/components/ClipboardInput';

import { editPassword } from 'basic/forms/editPassword';

import ProtectionOptions from './ProtectionOptions';


const RawProfileSecurityFormView = props => {
  const {
    protections,
    securityInfo,
    setSecurityInfo,
    getLangString: l
  } = props;
  
  
  const [isPinLoading, setIsPinLoading] = React.useState(false);
  const [pinCode, setPinCode] = React.useState();
  
  const {
    config: {
      API_METHOD,
      SECURITY_CHECK_TYPE,
      SHOP_GROUP_ORDER_ENABLED
    }
  } = useGlobal();
  
  React.useEffect(() => {
    setIsPinLoading(true);
    
    api.request('client/security/group_order_pin', {})
      .then((data) => setPinCode(data.code))
      .catch((error) => console.error(error))
      .finally((error) => setIsPinLoading(false));
  }, []);
  
  
  return (
    <div>
      <Grid container={true} justify="center">
        <Grid item={true} xs={12} sm={6} style={{ marginBottom: '20px' }}>
          <ProtectionOptions
            type={SECURITY_CHECK_TYPE.AUTH}
            protections={protections}
            securityInfo={securityInfo}
            setSecurityInfo={setSecurityInfo}
          />
        </Grid>

        <Grid item={true} xs={12} sm={6} style={{ marginBottom: '20px' }}>
          <ProtectionOptions
            type={SECURITY_CHECK_TYPE.FINOP}
            protections={protections}
            securityInfo={securityInfo}
            setSecurityInfo={setSecurityInfo}
          />
        </Grid>
      </Grid>

      <Grid container={true}>
        <Grid item={true} xs={12} sm={6} style={{ marginBottom: '20px' }}>
          <Typography variant="body1">{l('$r._.profile.edit.password')}</Typography>
          <FormWithValidation
            decor={editPassword}
            checkRequiredTouched={true}
            submitText={l('$r._.profile.security.action.save')}
            method={API_METHOD.VISITOR_EDIT_PASSWORD}
            renderFormBody={({ outerProps, innerProps }) => (
              <>
                {outerProps.renderFields(innerProps)}
                {outerProps.renderSuccess(innerProps)}
                {outerProps.renderFailure(innerProps)}
                {outerProps.renderProgress(innerProps)}
                {outerProps.renderResetButton(innerProps)}
                {outerProps.renderSubmitButton(innerProps)}
              </>
            )}
          />
        </Grid>
        
        {SHOP_GROUP_ORDER_ENABLED ? (
          <Grid item={true} xs={12} sm={6} style={{ marginBottom: '20px' }}>
            <Typography variant="body1">{l('$r._.profile.order.group')}</Typography>
            
            <ClipboardInput
              value={pinCode}
              label={l('$r._.profile.order.group.pin')}
              helperText={l('$r._.profile.order.group.pin.note')}
              endAdornment={
                isPinLoading ? (
                  <IconButton size="small">
                    <CircularProgress size={24} />
                  </IconButton>
                ) : (
                  <IconButton
                    size="small"
                    onClick={(event) => {
                      setIsPinLoading(true);
                      
                      api.request('client/security/group_order_pin', { update: true }, { requestCacheInterval: 1000 })
                        .then((data) => setPinCode(data.code))
                        .catch((error) => console.error(error))
                        .finally((error) => setIsPinLoading(false));
                    }}
                  >
                    <CachedIcon color="primary" />
                  </IconButton>
                )
              }
            />
          </Grid>
        ) : null}
      </Grid>
    </div>
  )
}

RawProfileSecurityFormView.defaultProps = {}

RawProfileSecurityFormView.propTypes = {
  // parent props
  securityInfo: PropTypes.object,

  // `withLang` HOC props
  langInfo: PropTypes.object,
  langStrings: PropTypes.object,
  getLangObject: PropTypes.func,
  getFirstLangString: PropTypes.func,
  getLangStringSet: PropTypes.func,
  getLangString: PropTypes.func.isRequired,
}

export const ProfileSecurityFormView = withLang(
  RawProfileSecurityFormView
)
